function idOf(value) {
  return value && value._id ? String(value._id) : String(value || "");
}

export function filterSupportUsersByProject(users, locations, projectLocationIds) {
  if (!(projectLocationIds instanceof Set) || projectLocationIds.size === 0) return [];

  const assignedUserIds = new Set();
  (locations || []).forEach(location => {
    if (!projectLocationIds.has(idOf(location?._id))) return;
    (location.user || []).forEach(user => assignedUserIds.add(idOf(user)));
  });

  return (users || []).filter(user => {
    const roles = Array.isArray(user.roles) ? user.roles : [];
    return user.activated === true &&
      !roles.some(role => role === "admin" || role === "api") &&
      assignedUserIds.has(idOf(user));
  });
}
